import { useEffect, useState } from 'react';
import { ShopkeeperForm } from '../components/ShopkeeperForm';
import { ShopkeeperList } from '../components/ShopkeeperList';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { Plus, List } from 'lucide-react';
import { CallAPIPromise } from '../routeBilling/menu/dashboard/biiling/modal/comman';
import { useDispatch, useSelector } from 'react-redux';
import { selectCompanyAddress, selectPrefix } from '../utility/Redux/profile';
import { setSpinnerLoading } from '../utility/Redux/modal';





export default function App() {
  // Mock party data
  const [parties, setParties] = useState([
    {
      id: 'p1',
      party_name: 'ABC Traders',
      mobile: '9876543210',
      contact_person: 'Rajesh Kumar',
      address: '123 MG Road',
      city: 'Mumbai',
      pin_code: '400001',
      is_shopkeeper: false,
    },
    {
      id: 'p2',
      party_name: 'XYZ Distributors',
      mobile: '9988776655',
      contact_person: 'Priya Sharma',
      address: '45 Park Street',
      city: 'Delhi',
      pin_code: '110001',
      is_shopkeeper: false,
    },
    {
      id: 'p3',
      party_name: 'Global Supplies',
      mobile: '9123456789',
      contact_person: 'Amit Patel',
      address: '78 Commercial Street',
      city: 'Bangalore',
      pin_code: '560001',
      is_shopkeeper: false,
    },
    {
      id: 'p4',
      party_name: 'Metro Electronics',
      mobile: '9898989898',
      contact_person: 'Sunita Reddy',
      address: '12 Tech Park',
      city: 'Hyderabad',
      pin_code: '500001',
      is_shopkeeper: false,
    },
  ]);

  const [shopkeepers, setShopkeepers] = useState([
    
  ]);

  const [editingShopkeeper, setEditingShopkeeper] = useState(null);
  const [activeTab, setActiveTab] = useState('add');
  const [refresh,setRefrsh]=useState(false)
  const prefix = useSelector(selectPrefix)
  const company = useSelector(selectCompanyAddress)
  const handleAddShopkeeper = (shopkeeper) => {
    dispatch(setSpinnerLoading("Loading"))
    console.log(company)
    CallAPIPromise("/api/shopkeeperMaster/saveShopkeeper", {
      ...shopkeeper,
      table_prefix: prefix,
      company_name:company.companyName,
      company_email:company.email
    }).then((res) => {
      console.log(res)
      setRefrsh(r=>!r)
    }).catch((e) => {
      console.log(e)
    }).finally(() => {
      dispatch(setSpinnerLoading(false))
    })
    
    
    setEditingShopkeeper(null);
    setActiveTab('list');
  };
  
const dispatch = useDispatch()
  const handleDeleteShopkeeper = (id) => {
    dispatch(setSpinnerLoading("Loading"))
    CallAPIPromise('/api/shopkeeperMaster/deleteShop', {
      account_no: id,
      table_prefix:prefix
    }).finally(() => {
      dispatch(setSpinnerLoading(false))
    })
    setRefrsh(r=>!r)
  };

  const handleEdit = (shopkeeper) => {
    setEditingShopkeeper(shopkeeper);
    setActiveTab('add');
  };

  const handleCancelEdit = () => {
    setEditingShopkeeper(null);
  };

  useEffect(() => {
    dispatch(setSpinnerLoading("Loading"))
      CallAPIPromise("/api/shopkeeperMaster/listShops", {
        table_prefix:prefix
      }).then((res) => {
       setShopkeepers(res?.data?.shops||[])
      }).catch((e) => {
     console.log(e)
      }).finally(() => {
        dispatch(setSpinnerLoading(false))
      })
},[refresh])

  return (
    <div className="h-full bg-gray-50 overflow-y-auto">
      <div className="container mx-auto py-8 px-4 max-w-6xl">
     

        <Tabs className="" value={activeTab} onValueChange={setActiveTab} >
        <TabsList className="grid grid-cols-2 w-full mb-3 bg-[#F3F3F5] rounded-lg p-1">
            <TabsTrigger value="add"     className="data-[state=active]:bg-white data-[state=active]:text-blue-600 
                 data-[state=active]:shadow-sm data-[state=active]:rounded-l-md rounded-r-none transition-all duration-300 
                 border-0 ">
              <Plus className="h-4 w-4" />
              Add Shopkeeper
            </TabsTrigger>
            <TabsTrigger value="list"    className="data-[state=active]:bg-white data-[state=active]:text-blue-600 
      data-[state=active]:shadow-sm transition-all duration-300 
      rounded-md border-0  data-[state=active]:rounded-r-md rounded-l-none ">
              <List className="h-4 w-4" />
              Shopkeeper List
            </TabsTrigger>
          </TabsList>

          <TabsContent value="add">
            <ShopkeeperForm
              onSubmit={handleAddShopkeeper}
              initialData={editingShopkeeper}
              onCancel={handleCancelEdit}
              parties={parties}
            />
          </TabsContent>

          <TabsContent value="list">
            <ShopkeeperList
              shopkeepers={shopkeepers}
              onEdit={handleEdit}
              onDelete={handleDeleteShopkeeper}
            />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
}